module.exports = __webpack_public_path__ + "img/rainbow6siege.014f7277.jpg";